import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Implementvaping() {
  return (
    <section className="implement_vaping p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>Implementations</h2>
            <p>
              We started working on a cross-platform mobile application and a
              web-based application providing access to the admin panel. The
              admin panel had access enabled to the clients only where they
              could manage features, check performance, view critical statistics
              and analysis, and analyze other essential app aspects. Other
              features that were added, include:
            </p>
            <p>
              We turned a conventional process into a simple two-step procedure
              where users are required to enter their email, password, and
              nickname.
            </p>
            <ul>
              <li>Sign-in/ Sign-up</li>
              <li>Start/Stop Vaping</li>
              <li>Leaderboard & Progress</li>
              <li>My Friends</li>
              <li>Daily/ Weekly Challenges</li>
              <li>Memories</li>
            </ul>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center"
          >
            <div className="implement_img">
              <StaticImage
                src="../../../images/case-studies/stop-vaping/implement.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={697}
                height={650}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Implementvaping;
